import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LearnDefaultImageDirective } from './learn-default-image.directive';

@NgModule({
  imports: [
    CommonModule,
    LearnDefaultImageDirective
  ],
  exports: [
    LearnDefaultImageDirective
  ]
})
export class LearnDefaultImageModule {
}
